import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

import appReducer from '../../layout/appSlice';
import configReducer from './configSlice';
import loginReducer from '../login/loginSlice';
import langReducer from '../lang/langSlice';
import tokenReducer from '../tokenHandling/tokenSlice';
import { partnerNetworkApi } from '../../services/partnerNetworkApi';
import { accountsApi } from '../../services/accountsApi';

// Create the root reducer independently to obtain the RootState type
const rootReducer = combineReducers({
    config: configReducer,
    lang: langReducer,
    app: appReducer,
    login: loginReducer,
    tokenHandling: tokenReducer,

    // Add the generated reducer as a specific top-level slice
    [partnerNetworkApi.reducerPath]: partnerNetworkApi.reducer,
    [accountsApi.reducerPath]: accountsApi.reducer,
});

export const getStore = (preloadedState?: Partial<RootState>) =>
    configureStore({
        reducer: rootReducer,
        preloadedState,

        // Adding the api middleware enables caching, invalidation, polling,
        // and other useful features of `rtk-query`.
        middleware: getDefaultMiddleware =>
            getDefaultMiddleware().concat([partnerNetworkApi.middleware, accountsApi.middleware]),
    });

export const store = getStore();

// Infer the store, state and dispatch types from the store instance
export type RootState = ReturnType<typeof rootReducer>;
export type RootStore = ReturnType<typeof getStore>;
export type AppDispatch = RootStore['dispatch'];

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
setupListeners(store.dispatch);
